import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CKEditor from "react-ckeditor-component";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {
  get_static_page_list,
  add_static_page
} from "../../../redux/actions/termsPolicyAndContactActions";
import loader from "../../../style/loader/loader.scss";
import "../../../style/manageTermsPolicyAndContact.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
let xCoordinate = {},
    yCoordinate = {};
class manageTermsPolicyAndContact extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAGE_TEMPLATE',
      path: ["Home","Manage Static Pages"],
      links: ["home",'manageTermsPolicies'],
      msgType: "",
      alertMessage: "",
      show: "",
      termsAndCondition: "",
      privacyPolicy: "",
      contactUs: "",
      termsAndConditionError: "",
      privacyPolicyError: "",
      aboutUs: "",
      aboutUsError: "",
      contactUsError: "",
      becomeAPartner: "",
      CheckOut: "",
      OrderThanks: "",
      Refferal: "",
      EmailSubscriptions: "",
      french_aboutUs: "",
      french_becomeAPartner: "",
      french_contactUs: "",
      french_privacyPolicy: "",
      french_termsAndCondition: "",
      french_CheckOut: "",
      french_OrderThanks: "",
      french_Refferal: "",
      french_EmailSubscriptions: "",
      multi_lang: 'no',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate = this.validate.bind(this);
    this.handleTermsAndCondition = this.handleTermsAndCondition.bind(this);
    this.handleFrenchTermsAndCondition = this.handleFrenchTermsAndCondition.bind(this);
    this.handlePrivacyPolicy = this.handlePrivacyPolicy.bind(this);
    this.handleFrenchPrivacyPolicy = this.handleFrenchPrivacyPolicy.bind(this);
    this.handleContactUs = this.handleContactUs.bind(this);
    this.handleFrenchContactUs = this.handleFrenchContactUs.bind(this);
    this.handleAboutUs = this.handleAboutUs.bind(this);
    this.handleFrenchAboutUs = this.handleFrenchAboutUs.bind(this);
    this.handleBecomePartner = this.handleBecomePartner.bind(this);
    this.handleFrenchBecomePartner = this.handleFrenchBecomePartner.bind(this);
    this.handleCheckOut = this.handleCheckOut.bind(this);
    this.handleFrenchCheckOut = this.handleFrenchCheckOut.bind(this);
    this.handleOrderThanks = this.handleOrderThanks.bind(this);
    this.handleFrenchOrderThanks = this.handleFrenchOrderThanks.bind(this);
    this.handleRefferal = this.handleRefferal.bind(this);
    this.handleFrenchRefferal = this.handleFrenchRefferal.bind(this);
    this.handleEmailSubscriptions = this.handleEmailSubscriptions.bind(this);
    this.handleFrenchEmailSubscriptions = this.handleFrenchEmailSubscriptions.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleTermsAndCondition(evt) {
    if (this.state.termsAndConditionError !== "") {
      this.setState({ termsAndConditionError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      termsAndCondition: newContent
    });
  }
  editSourceTermsAndCondition = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }
  handleFrenchTermsAndCondition(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_termsAndCondition: newContent
    });
  }
  editSourceFrenchTermsAndCondition = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }
  handlePrivacyPolicy(evt) {
    if (this.state.privacyPolicyError !== "") {
      this.setState({ privacyPolicyError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      privacyPolicy: newContent
    });
  }
  editSourcePrivacyPolicy = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }
  handleFrenchPrivacyPolicy(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_privacyPolicy: newContent
    });
  }
  editSourceFrenchPrivacyPolicy = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }
  handleContactUs(evt) {
    if (this.state.contactUsError !== "") {
      this.setState({ contactUsError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      contactUs: newContent
    });
  }

  editSourceContactUs = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchContactUs(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_contactUs: newContent
    });
  }
  editSourceFrenchContactUs = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }
  handleAboutUs(evt) {
    if (this.state.aboutUsError !== "") {
      this.setState({ aboutUsError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      aboutUs: newContent
    });
  }
  editSourceAboutUs = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchAboutUs(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_aboutUs: newContent
    });
  }

  editSourceFrenchAboutUs = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleBecomePartner(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      becomeAPartner: newContent
    });
  }
  editSourceBecomePartner = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchBecomePartner(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_becomeAPartner: newContent
    });
  }

  editSourceFrenchBecomePartner = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleCheckOut(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      CheckOut: newContent
    });
  }
  editSourceCheckOut = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchCheckOut(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_CheckOut: newContent
    });
  }
  editSourceFrenchCheckOut = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleOrderThanks(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      OrderThanks: newContent
    });
  }

  editSourceOrderThanks = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchOrderThanks(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_OrderThanks: newContent
    });
  }
  editSourceFrenchOrderThanks = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleRefferal(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      Refferal: newContent
    });
  }

  editSourceRefferal = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchRefferal(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_Refferal: newContent
    });
  }

  editSourceFrenchRefferal = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

    handleEmailSubscriptions(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      EmailSubscriptions: newContent
    });
  }

  editSourceEmailSubscriptions = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  handleFrenchEmailSubscriptions(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      french_EmailSubscriptions: newContent
    });
  }

  editSourceFrenchEmailSubscriptions = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  validate = () => {
    xCoordinate = {}
    yCoordinate = {}
    let isError = false;
    const errors = {};
    if (this.state.privacyPolicy.length === 0) {
      isError = true;
      this.setState({ privacyPolicyError: "red" });
      if(xCoordinate.key !== 'privacyPolicy'){
        let x = window.scrollX + document.querySelector('#privacyPolicy').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#privacyPolicy').getBoundingClientRect().top - 89
        xCoordinate['privacyPolicy'] = x;
        yCoordinate['privacyPolicy'] = y;
      }
    }
    if (this.state.termsAndCondition.length === 0) {
      isError = true;
      this.setState({ termsAndConditionError: "red" });
      if(xCoordinate.key !== 'termsAndCondition'){
        let x = window.scrollX + document.querySelector('#termsAndCondition').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#termsAndCondition').getBoundingClientRect().top - 89
        xCoordinate['termsAndCondition'] = x;
        yCoordinate['termsAndCondition'] = y;
      }
    }
    if (this.state.aboutUs.length === 0) {
      isError = true;
      this.setState({ aboutUsError: "red" });
      if(xCoordinate.key !== 'aboutUs'){
        let x = window.scrollX + document.querySelector('#aboutUs').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#aboutUs').getBoundingClientRect().top - 89
        xCoordinate['aboutUs'] = x;
        yCoordinate['aboutUs'] = y;
      }
    }
    if (this.state.contactUs.length === 0) {
      isError = true;
      this.setState({ contactUsError: "red" });
      if(xCoordinate.key !== 'contactUs'){
        let x = window.scrollX + document.querySelector('#contactUs').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#contactUs').getBoundingClientRect().top - 89
        xCoordinate['contactUs'] = x;
        yCoordinate['contactUs'] = y;
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.setState({ show: true });
    if (!err) {
      const addData = {
        termsAndCondition: this.state.termsAndCondition,
        privacyPolicy: this.state.privacyPolicy,
        contactUs: this.state.contactUs,
        aboutUs: this.state.aboutUs,
        becomeAPartner: this.state.becomeAPartner,
        checkout: this.state.CheckOut,
        order_text: this.state.OrderThanks,
        referral: this.state.Refferal,
        emailsubscriptions: this.state.EmailSubscriptions,
        french_termsAndCondition: this.state.french_termsAndCondition,
        french_privacyPolicy: this.state.french_privacyPolicy,
        french_contactUs: this.state.french_contactUs,
        french_aboutUs: this.state.french_aboutUs,
        french_becomeAPartner: this.state.french_becomeAPartner,
        french_checkout: this.state.french_CheckOut,
        french_order_text: this.state.french_OrderThanks,
        french_referral: this.state.french_Refferal,
        french_emailsubscriptions: this.state.french_EmailSubscriptions,
      };
      this.props.add_static_page(addData);
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
        window.scrollTo(xCoordinateValue,yCoordinateValue)
      }
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    this.props.get_static_page_list();
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (
      this.props.staticPageList !== nextProps.staticPageList &&
      !isEmpty(nextProps.staticPageList)
    ) {
      let privacyPolicyConst,
        aboutUsConst,
        termsAndConditionConst,
        contactUsConst,
        becomeAPartner,
        CheckOut,
        OrderThanks,
        Refferal,
        EmailSubscriptions,
        french_privacyPolicyConst,
        french_termsAndConditionConst,
        french_contactUsConst,
        french_aboutUsConst,
        french_CheckOut,
        french_OrderThanks,
        french_Refferal,
        french_EmailSubscriptions,
        french_becomeAPartner;
        nextProps.staticPageList.map((staticPage, index) => {
          privacyPolicyConst = staticPage.privacyPolicy;
          termsAndConditionConst = staticPage.termsAndCondition;
          contactUsConst = staticPage.contactUs;
          aboutUsConst = staticPage.aboutUs;
          becomeAPartner = staticPage.becomeAPartner;
          CheckOut = staticPage.checkout;
          OrderThanks = staticPage.order_text;
          Refferal = staticPage.referral;
          EmailSubscriptions = staticPage.emailsubscriptions;          
          french_privacyPolicyConst = staticPage.french_privacyPolicy;
          french_termsAndConditionConst = staticPage.french_termsAndCondition;
          french_contactUsConst = staticPage.french_contactUs;
          french_aboutUsConst = staticPage.french_aboutUs;
          french_becomeAPartner = staticPage.french_becomeAPartner;
          french_CheckOut = staticPage.french_checkout;
          french_OrderThanks = staticPage.french_order_text;
          french_Refferal = staticPage.french_referral;
          french_EmailSubscriptions = staticPage.french_emailsubscriptions;
        });
        this.setState({
          aboutUs: aboutUsConst,
          termsAndCondition: termsAndConditionConst,
          privacyPolicy: privacyPolicyConst,
          contactUs: contactUsConst,
          becomeAPartner: becomeAPartner,
          CheckOut: CheckOut,
          OrderThanks: OrderThanks,
          Refferal: Refferal,
          EmailSubscriptions: EmailSubscriptions,
          french_aboutUs: french_aboutUsConst,
          french_termsAndCondition: french_termsAndConditionConst,
          french_privacyPolicy: french_privacyPolicyConst,
          french_contactUs: french_contactUsConst,
          french_becomeAPartner: french_becomeAPartner,
          french_CheckOut: french_CheckOut,
          french_OrderThanks: french_OrderThanks,
          french_Refferal: french_Refferal,
          french_EmailSubscriptions: french_EmailSubscriptions,
        });
    }
    if (this.props.addedStaticPage !== nextProps.addedStaticPage) {
      this.props.clearAlert();
      this.handleShow();
      if (nextProps.addedStaticPage.message) {
        this.props.renderAlert("success", nextProps.addedStaticPage.message);
      }
      this.props.get_static_page_list();
      window.scrollTo(0, 0);
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);

      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="col-lg-12 static-pages">
        {this.props.receivingDetails === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div>
          <div className="row">
            {this.state.show &&
              this.state.alertMessage !== "" &&
              this.state.msgType && (
                <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Manage Static Pages</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <form onSubmit={this.handleSubmit}>
                    <Col md={8} xs={12} mdOffset={2}>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Privacy
                            Policy
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="privacyPolicy">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.privacyPolicyError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.privacyPolicy}
                            events={{
                              change: this.handlePrivacyPolicy,
                              blur: this.handlePrivacyPolicy,
                              afterPaste: this.handlePrivacyPolicy,
                              mode: this.editSourcePrivacyPolicy
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Privacy
                            Policy (Canadian French)
                          </ControlLabel>
                        </Col>
                      </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                      <Row id="french_privacyPolicy">
                        <Col md={12} xs={12}>
                          <CKEditor
                            content={this.state.french_privacyPolicy}
                            events={{
                              change: this.handleFrenchPrivacyPolicy,
                              blur: this.handleFrenchPrivacyPolicy,
                              afterPaste: this.handleFrenchPrivacyPolicy,
                              mode: this.editSourceFrenchPrivacyPolicy
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      }
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Terms And
                            Condition
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="termsAndCondition">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.termsAndConditionError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.termsAndCondition}
                            events={{
                              change: this.handleTermsAndCondition,
                              blur: this.handleTermsAndCondition,
                              afterPaste: this.handleTermsAndCondition,
                              mode: this.editSourceTermsAndCondition
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Terms And
                            Condition (Canadian French)
                          </ControlLabel>
                        </Col>
                      </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                      <Row id="french_termsAndCondition">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass="p10 initial-border"
                            content={this.state.french_termsAndCondition}
                            events={{
                              change: this.handleFrenchTermsAndCondition,
                              blur: this.handleFrenchTermsAndCondition,
                              afterPaste: this.handleFrenchTermsAndCondition,
                              mode: this.editSourceFrenchTermsAndCondition
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      }
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Contact Us
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="contactUs">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.contactUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.contactUs}
                            events={{
                              change: this.handleContactUs,
                              blur: this.handleContactUs,
                              afterPaste: this.handleContactUs,
                              mode: this.editSourceContactUs
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Contact Us (Canadian French)
                          </ControlLabel>
                        </Col>
                      </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                      <Row id="contactUs">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass="p10 initial-border"
                            content={this.state.french_contactUs}
                            events={{
                              change: this.handleFrenchContactUs,
                              blur: this.handleFrenchContactUs,
                              afterPaste: this.handleFrenchContactUs,
                              mode: this.editSourceFrenchContactUs
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      }
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>About Us
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="aboutUs">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.aboutUs}
                            events={{
                              change: this.handleAboutUs,
                              blur: this.handleAboutUs,
                              afterPaste: this.handleAboutUs,
                              mode: this.editSourceAboutUs
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              <span style={{ color: "red" }}>*</span>About Us (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row id="aboutUs">
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_aboutUs}
                              events={{
                                change: this.handleFrenchAboutUs,
                                blur: this.handleFrenchAboutUs,
                                afterPaste: this.handleFrenchAboutUs,
                                mode: this.editSourceFrenchAboutUs
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Become A Partner
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.becomeAPartner}
                            events={{
                              change: this.handleBecomePartner,
                              blur: this.handleBecomePartner,
                              afterPaste: this.handleBecomePartner,
                              mode: this.editSourceBecomePartner
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              Become A Partner (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_becomeAPartner}
                              events={{
                                change: this.handleFrenchBecomePartner,
                                blur: this.handleFrenchBecomePartner,
                                afterPaste: this.handleFrenchBecomePartner,
                                mode: this.editSourceFrenchBecomePartner
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }

                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Checkout
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="CheckOut">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.CheckOut}
                            events={{
                              change: this.handleCheckOut,
                              blur: this.handleCheckOut,
                              afterPaste: this.handleCheckOut,
                              mode: this.editSourceCheckOut
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              Checkout (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row id="CheckOut">
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_CheckOut}
                              events={{
                                change: this.handleFrenchCheckOut,
                                blur: this.handleFrenchCheckOut,
                                afterPaste: this.handleFrenchCheckOut,
                                mode: this.editSourceFrenchCheckOut
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }

                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Order Thanks
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="OrderThanks">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.OrderThanks}
                            events={{
                                change: this.handleOrderThanks,
                                blur: this.handleOrderThanks,
                                afterPaste: this.handleOrderThanks,
                                mode: this.editSourceOrderThanks
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              Order Thanks (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row id="OrderThanks">
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_OrderThanks}
                              events={{
                                change: this.handleFrenchOrderThanks,
                                blur: this.handleFrenchOrderThanks,
                                afterPaste: this.handleFrenchOrderThanks,
                                mode: this.editSourceFrenchOrderThanks
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }

                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Referral 
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="Refferal">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.Refferal}
                            events={{
                              change: this.handleRefferal
                            }}
                            events={{
                              change: this.handleRefferal,
                              blur: this.handleRefferal,
                              afterPaste: this.handleRefferal,
                              mode: this.editSourceRefferal
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              Referral (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row id="Referral">
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_Refferal}
                              events={{
                                change: this.handleFrenchRefferal,
                                blur: this.handleFrenchRefferal,
                                afterPaste: this.handleFrenchRefferal,
                                mode: this.editSourceFrenchRefferal
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Email Subscriptions 
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="email-subscriptions">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.EmailSubscriptions}
                            events={{
                              change: this.handleEmailSubscriptions
                            }}
                            events={{
                              change: this.handleEmailSubscriptions,
                              blur: this.handleEmailSubscriptions,
                              afterPaste: this.handleEmailSubscriptions,
                              mode: this.editSourceEmailSubscriptions
                            }}
                            config={{allowedContent: true}}
                          />
                        </Col>
                      </Row>
                      {(this.state.multi_lang == "yes") &&
                        <Row>
                          <Col md={12} xs={12}>
                            <hr />
                          </Col>
                          <Col md={12} xs={12}>
                            <ControlLabel>
                              Email Subscriptions (Canadian French)
                            </ControlLabel>
                          </Col>
                        </Row>
                      }
                      {(this.state.multi_lang == "yes") &&
                        <Row id="email-subscriptions">
                          <Col md={12} xs={12}>
                            <CKEditor
                              activeClass="p10 initial-border"
                              content={this.state.french_EmailSubscriptions}
                              events={{
                                change: this.handleFrenchEmailSubscriptions,
                                blur: this.handleFrenchEmailSubscriptions,
                                afterPaste: this.handleFrenchEmailSubscriptions,
                                mode: this.editSourceFrenchEmailSubscriptions
                              }}
                              config={{allowedContent: true}}
                            />
                          </Col>
                        </Row>
                      }
                    </Col>
                    <Row>
                      <Col md={12} xs={12}>
                        <div style={{ color: "red" }}>* field are required</div>
                      </Col>
                    </Row>
                    <Row className="BtnRow">
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="info"
                          type="submit"
                          id="save-button"
                          disabled={this.props.sending}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

manageTermsPolicyAndContact.propTypes = {
  get_static_page_list: PropTypes.func.isRequired,
  add_static_page: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  staticPageList: state.termsPolicyAndContactReducer.staticPageList,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  addedStaticPage: state.termsPolicyAndContactReducer.addedStaticPage,
  sending: state.termsPolicyAndContactReducer.sending,
  receivingDetails: state.termsPolicyAndContactReducer.receivingDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    get_static_page_list,
    add_static_page,
    clearAlert,
    renderAlert
  })
)(manageTermsPolicyAndContact);



// WEBPACK FOOTER //
// ./src/app/views/admin/manageTermsPolicies/manageTermsPolicyAndContact.js